import axios from '../../plugins/axios'
import FinanceiroInterceptor from '../../plugins/FinanceiroInterceptor'

export const actions = {
    listarBE(context, payload) {
        return new Promise(function (resolve, reject) {
            axios.get('auditoria' + payload)
                .then(function (response) { resolve(response) })
                .catch(function (error) { reject(error) })
        })
    },
    listarBF(context, payload) {
        return new Promise(function (resolve, reject) {
            FinanceiroInterceptor.get('auditoria' + payload)
                .then(function (response) { resolve(response) })
                .catch(function (error) { reject(error) })
        })
    },
}



// WEBPACK FOOTER //
// ./src/store/modules/auditoria.js